import { defineAction } from '~/prix'
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import emergencyDispatchDeleteAction from './emergencyDispatchDelete.action.json' with { type: 'json' }

const emergencyDispatchDeleteDefinition = defineAction({
  ...emergencyDispatchDeleteAction,

  input: z.object({
    id: z.string().uuid(),
    updatedAt: dateOrIsoString().nullish(),
    syncronizedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default emergencyDispatchDeleteDefinition
